export const readOnlyFields = ["promoMethods"];
